<template>
  <div>
    <notice-list v-if="tabType === 1" @handleShow="handleShow" />
  </div>
</template>

<script>
import noticeList from './list.vue'
export default {
  components: { noticeList },
  data() {
    return {
      tabType: 1,
      rowItem: null,
      technicalState:null
    }
  },
  methods: {
    handleShow(row, type) {
      this.tabType=type
      this.rowItem = { ...row }
    }
  }
}
</script>

<style>
</style>
